import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'
import LanguageStrings from '../../../i18n/locales'

export const Ztag = z.object({
  name: z.string()
})
export const ZAssetList = z.object({
  name: z.string(),
  description: z.string()
})
export const ZData = z.object({
  total_count: z.number(),
  assets: ZAssetList.array()
})
export const ZApiResponse = z.object({
  http_status: z.any(),
  data: z.optional(ZData),
  error: z.boolean(),
  error_message: z.optional(z.string())
})
export type AssetList = z.infer<typeof ZAssetList>
export type Tag = z.infer<typeof Ztag>

export const getSortField: any = (sortfield: string): string => {
  // istanbul ignore next
  if (sortfield === 'serial_number') {
    sortfield = 'serialNumber'
  } else if (sortfield === 'install_date') {
    sortfield = 'installDate'
  } else if (sortfield === 'removal_date') {
    sortfield = 'removalDate'
  } else if (sortfield === 'state') {
    sortfield = 'lifecycleDetails.stateDefinition'
  }
  return sortfield
}

export async function getAssetList (
  siteId: string,
  assetTypeId: string,
  PageNumber: number,
  PageItems: number,
  searchKey: string,
  SortParams: string,
  parentAssetId: string,
  sortField: string,
  onSuccess: (assetList: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const AssetManagementStrings = LanguageStrings().AssetManagementCollectionStrings.TableComponent
  const Sorting = (sortField !== '' && sortField != null) ? `${sortField},${SortParams}` : 'installDate,DESC'
  const url = `/assetrest/api/v2/udp/tiq/assets?siteId=${siteId}&assetTypeId=${assetTypeId}&page=${PageNumber - 1}&size=${PageItems}&search=${searchKey}&sort=${Sorting}`

  interceptedAxios.get(url, { timeout: 15000 })
    .then((response) => {
      const parseResponse = response.data
      // istanbul ignore else
      if (parseResponse.error === false) {
        // istanbul ignore else
        if (parseResponse.data !== null && parseResponse.data !== undefined) {
          onSuccess(parseResponse.data, parseResponse.http_status)
        } else {
          onFailure(parseResponse.error, parseResponse.http_status)
        }
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error) => {
      // istanbul ignore next
      if (error.response !== undefined) {
        onFailure((error.response.data !== undefined || error.response.data !== null) ? error.response.data.error_message : AssetManagementStrings.NetworkError, error.response.status)
      } else {
        onFailure(AssetManagementStrings.NetworkError, 404)
      }
    })
}
